import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  Box,
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListSubheader,
} from "@mui/material";
import moment from "moment";
import { useState } from "react";

import { TDateISO } from "api/common/types/datetime.types";

const formatDate = (date: TDateISO) => {
  if (!date) return "No Date";
  return moment.utc(date).format("MM/DD/YYYY");
};

const calculateBullet = (progressPoint: number, index: number) => {
  const prefix = index === 0 ? ". " : String.fromCharCode(96 + index) + ".";
  return `${progressPoint}${prefix}`;
};

interface EventsListProps {
  dateList: TDateISO[];
  progressPoint: number;
  header: string;
}

const EventsList = ({ dateList, progressPoint, header }: EventsListProps) => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const isMulti = dateList.length > 1;
  const [firstDate, ...remainingDates] = dateList;

  return (
    <List
      subheader={
        <ListItemButton
          sx={{
            padding: 0,
            "&.Mui-disabled": { opacity: 1 },
            justifyContent: "space-between",
            alignItems: "stretch",
          }}
          onClick={handleClick}
          disabled={!isMulti}
        >
          <ListSubheader
            sx={{
              padding: "3px 0",
              marginBottom: "3px",
              background: "transparent",
              lineHeight: "1",
              fontSize: "14px",
            }}
          >
            {header}:
          </ListSubheader>

          {isMulti &&
            (open ? (
              <RemoveIcon fontSize={"small"} />
            ) : (
              <AddIcon fontSize={"small"} />
            ))}
        </ListItemButton>
      }
      dense={true}
    >
      <EventDate
        bulletText={calculateBullet(progressPoint, 0)}
        dateText={formatDate(firstDate)}
      />

      {remainingDates.length > 0 && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List dense={true} disablePadding>
            {remainingDates.map((date, idx) => (
              <EventDate
                bulletText={calculateBullet(progressPoint, idx + 1)}
                dateText={formatDate(date)}
                key={date}
              />
            ))}
          </List>
        </Collapse>
      )}
    </List>
  );
};

export default EventsList;

interface EventDateProps {
  bulletText: string;
  dateText: string;
}
const EventDate = ({ bulletText, dateText }: EventDateProps) => {
  return (
    <ListItem
      sx={{
        padding: "3px 0px",
      }}
    >
      <Box minWidth={"18px"} mr={1}>
        {bulletText}
      </Box>
      <Box>{dateText}</Box>
    </ListItem>
  );
};
